import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '@services/loader.service';
import { Observable, finalize, mergeMap, of, timer } from 'rxjs';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let showLoader = false;
    const isPost = req.method.toUpperCase() === 'POST';

    if (isPost) {
      showLoader = true;
      this.loaderService.show();

      return next.handle(req).pipe(
        finalize(() => {
          if (showLoader) {
            this.loaderService.hide();
          }
        }),
      );
    }

    const delayedShow$ = timer(800).pipe(
      mergeMap(() => {
        showLoader = true;
        this.loaderService.show();
        return of(null);
      }),
    );

    const handle$ = next.handle(req).pipe(
      finalize(() => {
        if (showLoader) {
          this.loaderService.hide();
        }
      }),
    );

    return delayedShow$.pipe(mergeMap(() => handle$));
  }
}
